import { createSlice } from '@reduxjs/toolkit';

const initialState = null;

const dialogSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    setDialog: (state, action) => ({ dialog: action.payload }),
    clearDialog: () => null,
  },
});

export const { setDialog, clearDialog } = dialogSlice.actions;

export default dialogSlice.reducer;

export const selectCurrentDialog = (state) => state.dialog?.dialog;
